<section class="loader-section" *ngIf="this.restAPIService.loading">
    <img src="assets/images/loader-img.svg" alt="Loading..." class="loader-img" />
</section>
<router-outlet></router-outlet>